import React, { useState, useEffect, useContext } from 'react';
import { Modal, Col, Form, Row } from 'react-bootstrap';
import { DataContext } from '../../../init/getData';
import { numberFormatter } from '../../../components/formatters/numberFormatter';

const Exchange = (props) => {
  const { settingData } = useContext(DataContext);
  const { finalNetTotal, selectedCurrency } = props;

  // Determine which currency is being used
  const isMainCurrency = selectedCurrency === settingData.mainCurrencyId;
  const currencyLabel = isMainCurrency 
    ? settingData.mainCurrency?.symbol || settingData.mainCurrency?.name || 'Main'
    : settingData.secondaryCurrency?.symbol || settingData.secondaryCurrency?.name || 'Secondary';

  // State for amounts in the selected currency
  const [paid, setPaid] = useState(0);
  const [returned, setReturned] = useState(0);
  const [remaining, setRemaining] = useState(finalNetTotal || 0);

  // Handle changes in payments
  const handlePaidChange = (value) => {
    const numericValue = parseFloat(value) || 0;
    setPaid(numericValue);
    calculateRemaining(numericValue, returned);
  };

  // Handle changes in returns
  const handleReturnedChange = (value) => {
    const numericValue = parseFloat(value) || 0;
    setReturned(numericValue);
    calculateRemaining(paid, numericValue);
  };

  // Calculate remaining amount
  const calculateRemaining = (paid, returned) => {
    const remainingAmount = (finalNetTotal || 0) - paid + returned;
    setRemaining(remainingAmount);
  };

  // Update remaining amount when finalNetTotal changes
  useEffect(() => {
    calculateRemaining(paid, returned);
  }, [finalNetTotal]);

  return (
    <div style={{ marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
      <Row className="mb-3 justify-content-center">
        {/* Paid Amount Input */}
        <Form.Group as={Col} md={4}>
          <Form.Label>Paid {currencyLabel}</Form.Label>
          <Form.Control
            type="number"
            value={paid}
            onChange={(e) => handlePaidChange(e.target.value)}
            style={{ textAlign: 'center' }}
          />
        </Form.Group>
      </Row>

      <Row className="mb-3 justify-content-center">
        {/* Returned Amount Input */}
        <Form.Group as={Col} md={4}>
          <Form.Label>Returned {currencyLabel}</Form.Label>
          <Form.Control
            type="number"
            value={returned}
            onChange={(e) => handleReturnedChange(e.target.value)}
            style={{ textAlign: 'center' }}
          />
        </Form.Group>
      </Row>

      <Row className="mb-3 justify-content-center">
        {/* Remaining Amount Display */}
        <Form.Group as={Col} md={4}>
          <Form.Label>Remaining {currencyLabel}</Form.Label>
          <Form.Control
            type="text"
            value={numberFormatter(remaining, 2)}
            readOnly
            style={{ textAlign: 'center', fontWeight: 'bold' }}
          />
        </Form.Group>
      </Row>
    </div>
  );
};

export default Exchange;